import { useContext } from 'react';
import { useTranslation } from 'react-i18next';

import { TYPE_OF_EMPLOYMENT } from 'bxcommon/constants/employment.constants';
import { searchForLabel } from 'bxcommon/helpers/common.helpers';
import { SummaryFilesList } from 'bxcommon/components/SummaryHelpers/SummaryFiles';
import { RequestContext } from 'bxcommon/context/Request.context';
import { summaryValuesIterator } from 'bxcommon/helpers/common.helpers';
import { BaseBox, BaseBoxHeading, SummaryInput } from 'bxcommon';

export const CompanyInformationDetails = (props) => {
  const { t } = useTranslation();
  const { company } = props;
  const {
    resources: { countries, ombudsman_options, employment_types },
  } = useContext(RequestContext);

  const employmentTypes = employment_types.data ?? TYPE_OF_EMPLOYMENT;

  return (
    <div>
      <BaseBox borderless className="base-summary__section">
        <BaseBoxHeading className="base-summary__subheading">
          {t('request.summary.headings.companyInformation')}
        </BaseBoxHeading>

        <ul className="base-summary__content">
          <SummaryInput
            name={t('request.form.companyInformation.employmentRelationship')}
            data-testid="summary-type-of-employment"
          >
            {searchForLabel(employmentTypes, company.type_of_employment)}
          </SummaryInput>
          <SummaryInput name={t('request.form.companyInformation.company_name')} data-testid="summary-company-name">
            {company.name}
          </SummaryInput>
          <SummaryInput name={t('request.summary.address')}>
            {(company.address_line_1 || company.address_line_1) && (
              <span className="base-summary__address">
                <span className="base-summary--margin" data-testid="summary-company-address-line-1">
                  {company.address_line_1}
                </span>
                <span className="base-summary--margin" data-testid="summary-company-address-line-2">
                  {company.address_line_2}
                </span>
              </span>
            )}
          </SummaryInput>
          <SummaryInput
            name={`
              ${t('request.form.common.postcode')} /
              ${t('request.form.common.city')}`}
            data-testid="summary-company-city"
          >
            {(company.postcode || company.city) && (
              <>
                {company.postcode} {company.city}
              </>
            )}
          </SummaryInput>

          <SummaryInput name={t('request.form.common.country')} data-testid="summary-company-country">
            {searchForLabel(countries, company.country)}
          </SummaryInput>
        </ul>
      </BaseBox>
      <BaseBox borderless className="base-summary__section">
        <BaseBoxHeading className="base-summary__subheading">
          {t('request.summary.headings.jobDescription')}
        </BaseBoxHeading>

        <ul className="base-summary__content">
          <SummaryInput
            name={t('request.form.jobDescription.job_function')}
            data-testid="summary-company-job-function"
          >
            {company.job_function}
          </SummaryInput>
          <SummaryInput
            name={t('request.form.jobDescription.job_position')}
            data-testid="summary-company-job-position"
          >
            {company.job_position}
          </SummaryInput>
        </ul>
      </BaseBox>
      <BaseBox borderless className="base-summary__section">
        <BaseBoxHeading className="base-summary__subheading">
          {t('request.summary.headings.associatedOmbudsman')}
        </BaseBoxHeading>
        {summaryValuesIterator(ombudsman_options.data, company.ombudsman_offices)}
      </BaseBox>
      <BaseBox borderless className="base-summary__section">
        <BaseBoxHeading className="base-summary__subheading">{t('request.summary.headings.documents')}</BaseBoxHeading>
        <SummaryInput name={t('request.summary.confirmationOfEmployment')}>
          <SummaryFilesList files={company.confirmation_of_employment_files} download />
        </SummaryInput>
        <SummaryInput name={t('request.summary.liabilityInsuranceOrCoverage')}>
          <SummaryFilesList files={company.liability_insurance_files} download />
        </SummaryInput>
        <SummaryInput name={t('request.summary.documentOfAffiliation')}>
          <SummaryFilesList files={company.document_of_affiliation_files} download />
        </SummaryInput>
      </BaseBox>
    </div>
  );
};

export default CompanyInformationDetails;
